import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import { isNilOrEmpty } from 'ramdasauce'
import cn from 'classnames'

import { useStyles } from './styles'
import { Text, SanityButton, Animated } from 'components/atoms'

export const HeroImage = ({ data }) => {
  const classes = useStyles()

  const isTextPresent =
    !isNilOrEmpty(data.titleText) || !isNilOrEmpty(data.subtitleText)
  const isCTAPresent = isNilOrEmpty(data.ctaButton)

  const titleClasses = cn({
    [classes.title]: true,
    [classes.navy]: data.textColor === 'Navy',
    [classes.blue]: data.textColor === 'Light Blue',
  })
  const subTitleClasses = cn({
    [classes.subTitle]: true,
    [classes.navy]: data.textColor === 'Navy',
    [classes.blue]: data.textColor === 'Light Blue',
  })

  return (
    <div className={classes.wrapper}>
      <div className={classes.imageOverlay} />

      {!isNilOrEmpty(data.backgroundImage) && (
        <GatsbyImage
          image={data.backgroundImage.asset.gatsbyImageData}
          alt={data.backgroundImage.title}
          className={classes.image}
          placeholder="none"
        />
      )}
      {isTextPresent && (
        <div className={classes.textBlock}>
          <Animated type="fade-in">
            <div>
              <Text size="header5" tag="h1" className={titleClasses}>
                {data.titleText}
              </Text>
            </div>
            <div>
              <Text size="subhead2" tag="h2" className={subTitleClasses}>
                {data.subtitleText}
              </Text>
            </div>
            {isCTAPresent && (
              <div className={classes.buttonWrapper}>
                <SanityButton data={data.button} />
              </div>
            )}
          </Animated>
        </div>
      )}
    </div>
  )
}

HeroImage.propTypes = {
  data: PropTypes.object,
}

HeroImage.defaultProps = {
  data: {},
}
